import type { Disclosure } from '@/components/common/helpers';
import { Modal, ModalContent, ModalFooter, Button } from '@/components/ui';
import type { ReactNode } from 'react';
import { LoadingBar } from './loading';

export function BasicModal({
  disclosure,
  ready,
  loading,
  loadingContent,
  children,
}: {
  disclosure: Disclosure;
  ready?: boolean;
  loading?: boolean;
  loadingContent?: ReactNode;
  onClose?: () => void;
  children: ReactNode;
}) {
  const Loading = () => {
    if (!loading) {
      return undefined;
    }

    return (
      loadingContent || (
        <div className='m-6'>
          <LoadingBar loading />
        </div>
      )
    );
  };

  return (
    <Modal
      isOpen={disclosure.isOpen}
      onOpenChange={disclosure.onOpenChange}
      onClose={disclosure.onClose}
      scrollBehavior='inside'
    >
      <ModalContent>
        {ready && (loading ? <Loading /> : <>{children}</>)}
      </ModalContent>
    </Modal>
  );
}

export function BasicModalFooter({
  showCancel = true,
  cancelLabel = 'Cancel',
  onCancel,
  showApply = true,
  applyLabel = 'OK',
  onApply,
  applyDisabled = false,
  cancelDisabled = false,
  applyLoading = false,
}: {
  showCancel?: boolean;
  cancelLabel?: string;
  onCancel?: () => void;
  showApply?: boolean;
  applyLabel?: string;
  onApply?: () => void;
  applyDisabled?: boolean;
  cancelDisabled?: boolean;
  applyLoading?: boolean;
}) {
  return (
    <ModalFooter>
      {showCancel && (
        <Button onPress={onCancel} variant='flat' isDisabled={cancelDisabled}>
          {cancelLabel}
        </Button>
      )}
      {showApply && (
        <Button
          onPress={onApply}
          variant='solid'
          color='primary'
          isDisabled={applyDisabled}
          isLoading={applyLoading}
        >
          {applyLabel}
        </Button>
      )}
    </ModalFooter>
  );
}
